// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-2d64f02e]::-webkit-outer-spin-button,\ninput[data-v-2d64f02e]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-2d64f02e] {\n  -moz-appearance: textfield;\n}\nbutton[data-v-2d64f02e] {\n  background-color: #984422;\n}", ""]);
// Exports
module.exports = exports;
